import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'core/store';

interface ProjectsMetaState { 
  activeProjectKey: string; 
}

const initialState: ProjectsMetaState = { activeProjectKey: '' };

const projectsMetaSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    activeProjectChanged: (state, action) => {
      state.activeProjectKey = action.payload;
    },
  },
});

export const { activeProjectChanged } = projectsMetaSlice.actions;
export const selectActiveProjectKey = (state: RootState) => state.projects.activeProjectKey;

export default projectsMetaSlice;
